module.exports = __webpack_public_path__ + "assets/img/jianhao.0be864e2.svg";